export const ARROW_DIRECTIONS = {
  LEFT: "left",
  RIGHT: "right",
} as const;
